module.exports = __webpack_public_path__ + "static/img/clothing_12.4fae9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/clothing_12.png
// module id = 2ksa
// module chunks = 0